export const SIZE_CHART_TEXTS = {
  referenceTable: 'Ten en cuenta que se trata de una tabla referencial y que puede variar dependiendo de la marca.',
  betweenSizesTitle: '¿Estás entre dos tallas?',
  betweenSizesRecommendation:
    'Te recomendamos que elijas la talla más grande y te los pruebes al recibirlos. Si no te quedaron bien, ¡no te preocupes! Con nuestra',
  satisfactionGuarantee: 'Satisfacción Garantizada',
  returnPolicy: 'tienes 30 días para cambiar o devolver fácil en cualquier tienda Falabella.',
};

const TENANT_CONFIG = {
  falabella_cl: { domain: 'falabella.com', path: 'falabella-cl' },
  falabella_pe: { domain: 'falabella.com.pe', path: 'falabella-pe' },
  falabella_co: { domain: 'falabella.com.co', path: 'falabella-co' },
};

export const getSatisfactionGuaranteeUrl = (tenant) => {
  const normalizedTenant = tenant?.replace(/-/g, '_');
  const config = TENANT_CONFIG[normalizedTenant] || TENANT_CONFIG.falabella_cl;
  return `https://www.${config.domain}/${config.path}/page/devoluciones`;
};
